export default __webpack_public_path__ + "6c03eb2.png";